<ng-container *ngIf="airSearchForm && hostFieldSpec">
    <h2 class="form-title">{{ wording.host }}</h2>
    <form [formGroup]="airSearchForm">
        <multiselect
                [fieldConfig]="hostFieldSpec"
                [options]="hostsList">
        </multiselect>
    </form>
</ng-container>
